import { Record as record } from 'immutable';
import { construct, fields } from '../../../src/helpers/LinkMapper';
import trainTime from '../../../src/lib/TrainTime';

const defaults = {
    id: null,
    value: null,
    minDate: null
};

export default class DelayRepayTime extends record(defaults) {
    static fromJSON (json = {}) {
        return construct(DelayRepayTime, json, {
            id: fields.string,
            value: fields.string,
            minDate: fields.datetime
        });
    }

    isValid () {
        return !this.minDate || this.minDate.isBefore(trainTime());
    }
}
